/*
  Hero visual: a single SHERIFF-AI alert card, drawn the way the product
  actually presents one — plain-English explanation, what was done about it,
  and the human-in-command Approve / Dismiss decision. This replaces the old
  decorative radar: it shows the thing the product is actually differentiated
  by instead of ambience.

  Static illustration of the real UI (labelled as such — no fake live data);
  the "buttons" are presentational, not interactive.
*/
export function AlertPreview() {
  return (
    <div className="glass w-full max-w-sm rounded-xl2 p-5 text-left">
      {/* Card header */}
      <div className="flex items-center justify-between gap-3">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-border px-3 py-1 text-sm font-semibold text-warn">
          <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[var(--warn)]" />
          Medium severity
        </span>
        <span className="whitespace-nowrap text-xs text-muted">Illustrative example</span>
      </div>

      {/* What happened, in plain English */}
      <h3 className="mt-4 text-lg font-bold tracking-tight text-text">
        Suspicious script blocked
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-muted">
        A program on <span className="font-mono text-text">cafe-node-17</span>{" "}
        tried to run a hidden shell command right after a USB drive was plugged
        in. The file is held in quarantine — nothing has been deleted.
      </p>

      {/* Recommended action */}
      <div className="mt-4 rounded-lg border border-border bg-[color-mix(in_srgb,var(--surface-solid)_60%,transparent)] px-4 py-3">
        <p className="text-sm text-muted">
          <span className="font-semibold text-text">Recommended:</span> keep the
          file quarantined and run a scan of the device.
        </p>
      </div>

      {/* Human-in-command decision row (presentational) */}
      <div aria-hidden className="mt-4 flex items-center gap-3">
        <span className="inline-flex min-h-[40px] items-center justify-center rounded-lg bg-accent px-4 text-sm font-semibold text-accent-ink">
          Approve
        </span>
        <span className="inline-flex min-h-[40px] items-center justify-center rounded-lg border border-border px-4 text-sm font-semibold text-text">
          Dismiss
        </span>
      </div>

      <p className="mt-4 border-t border-border pt-3 text-sm text-muted">
        SHERIFF-AI explains every alert and never acts without your approval.
      </p>
    </div>
  );
}
